import { RootReduxStateShape } from '_types/Redux';
import { useSelector } from 'react-redux';
import { FlashMessageShape } from '../type';

const useFlash = (): { messages: FlashMessageShape[] } => {
    const { messages } = useSelector(
        (state: RootReduxStateShape) => state.flash,
    );
    return { messages };
};

export default useFlash;
